(function () {
  // ===========================
  // CONFIG
  // ===========================
  const SF_ENDPOINT =
    "https://ilumi.my.salesforce-sites.com/public/services/apexrest/utm/params";

  const LS_SESSION_ID_KEY = "ilumi_utm_local_session_id"; // shared across tabs
  const LS_SENT_FLAG_KEY = "ilumi_utm_sent_to_sf";
  const LS_SENT_AT_KEY = "ilumi_utm_sent_to_sf_at"; // ISO string
  const LS_UTM_CACHE_KEY = "ilumi_utm_cached_from_optimunk"; // optional cache

  const OPTIMONK_KEY = "OptiMonkVisitorAttributes";

  // 24 hours in ms
  const RESET_AFTER_MS = 24 * 60 * 60 * 1000;

  // ===========================
  // UTIL
  // ===========================
  function nowMs() {
    return Date.now();
  }

  function safeJsonParse(str) {
    if (!str) return null;
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  function getOrCreateLocalSessionId() {
    let id = localStorage.getItem(LS_SESSION_ID_KEY);
    if (!id) {
      // crypto.randomUUID() is supported in modern Chrome; fallback included
      id =
        (window.crypto && crypto.randomUUID && crypto.randomUUID()) ||
        "sid-" +
          Math.random().toString(16).slice(2) +
          "-" +
          Date.now().toString(16);
      localStorage.setItem(LS_SESSION_ID_KEY, id);
    }
    return id;
  }

  function getSentState() {
    const sentFlag = localStorage.getItem(LS_SENT_FLAG_KEY) === "true";
    const sentAtStr = localStorage.getItem(LS_SENT_AT_KEY);
    const sentAtMs = sentAtStr ? Date.parse(sentAtStr) : NaN;

    return { sentFlag, sentAtStr, sentAtMs };
  }

  function resetSentState() {
    localStorage.setItem(LS_SENT_FLAG_KEY, "false");
    localStorage.removeItem(LS_SENT_AT_KEY);
  }

  function refreshSentStateIfExpired() {
    const { sentFlag, sentAtMs } = getSentState();
    if (!sentFlag) return;

    if (!isFinite(sentAtMs) || nowMs() - sentAtMs >= RESET_AFTER_MS) {
      resetSentState();
    }
  }

  // ===========================
  // OPTIMONK UTMs
  // ===========================
  function getOptiMonkAttributes() {
    return safeJsonParse(localStorage.getItem(OPTIMONK_KEY));
  }

  function decodeMaybe(value) {
    // OptiMonk values sometimes look URL-encoded (e.g., first_landing_page)
    if (value == null) return null;
    if (typeof value !== "string") return value;

    // Only attempt decode if it seems encoded
    if (value.includes("%")) {
      try {
        return decodeURIComponent(value);
      } catch (e) {
        return value;
      }
    }
    return value;
  }

  function getUtmDataFromOptiMonk() {
    const attrs = getOptiMonkAttributes();
    if (!attrs) return null;

    const utm = {
      utm_source: attrs.utm_source || null,
      utm_medium: attrs.utm_medium || null,
      utm_campaign: attrs.utm_campaign || null,
      utm_content: attrs.utm_content || null,
      utm_term: attrs.utm_term || null
    };

    // Landing / referrer references from OptiMonk (often encoded)
    const landingUrl =
      decodeMaybe(attrs._source_url) ||
      window.location.href;

    const referrer = decodeMaybe(attrs._source_referrer) || document.referrer || null;

    // Consider this a "valid" UTM payload if it has at least source or campaign
    const hasAttribution = !!(utm.utm_source || utm.utm_campaign);

    if (!hasAttribution) return null;

    // Cache for convenience (optional)
    localStorage.setItem(
      LS_UTM_CACHE_KEY,
      JSON.stringify({ utm, landingUrl, referrer })
    );

    return { utm, landingUrl, referrer };
  }

  // ===========================
  // SEND TO SALESFORCE
  // ===========================
  async function sendToSalesforce(payload) {
    // Fire-and-forget; do not block navigation/UX
    try {
      await fetch(SF_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        // keepalive helps when navigating away right after click (supported in modern browsers)
        keepalive: true
      });
    } catch (e) {
      console.error(e)
    }
  }

  // Reset sent flag if 24h passed
  refreshSentStateIfExpired();

  // Expose click handler for your WhatsApp button
  window.sendUTMToSalesforce = function () {
    refreshSentStateIfExpired();

    const { sentFlag } = getSentState();
    if (sentFlag) {
      // already sent within last 24 hours; skip
      return;
    }

    const data = getUtmDataFromOptiMonk();
    if (!data) return;

    const sessionId = getOrCreateLocalSessionId();

    const payload = {
      sessionId,
      ...data.utm,
      landingUrl: data.landingUrl,
      referrer: data.referrer,
      clickedAt: new Date().toISOString()
    };

    // Mark as sent BEFORE sending to avoid multiple rapid clicks
    localStorage.setItem(LS_SENT_FLAG_KEY, "true");
    localStorage.setItem(LS_SENT_AT_KEY, new Date().toISOString());

    // send
    void sendToSalesforce(payload);
  };
})();
